import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';
import { RouterModule } from '@angular/router';
import { tooltipMessageComponent } from './tooltip-message.component';



@NgModule({
  declarations: [tooltipMessageComponent],
  imports: [
    CommonModule,
    RouterModule,
    MatIconModule,
    MatTooltipModule
  ],
  exports: [tooltipMessageComponent]
})
export class TooltipMessageModule { }
